export default __webpack_public_path__ + "static/media/logo.c4aec36d.png";